module.exports = __webpack_public_path__ + "img/alert-error.a6a19d85.png";